import Component from '../abstracts/Component';
import {buildFullQuery, buildQuery} from "../utils/SearchUrlUtil";
import ajaxAction from '../utils/ajaxUtil';
import {CustomEvents} from "../utils/CustomEvents";
import {replacePageInHistory} from "../utils/BrowserHistoryUtils";
import CarouselComponent from "./CarouselComponent";

export default class PaginationComponent extends Component {

  get SELECTORS() {
    return {
      pagers: '.js-item-pagination *[data-page]:not(.navigation-item--disabled)',
      productsContainer: '[data-products-container]',
      pageSalesPagination: '[data-sales-pagination]',
      pageSalesPaginationPage: '[data-sales-pagination] a'
    }
  }

  get CLASSES() {
    return {
      salesLinkActive: 'selected'
    }
  }

  constructor() {
    super();
    // ajax
    this.ajaxAction = new ajaxAction();
    // sales
    this.pageSalesPagination = document.querySelector(this.SELECTORS.pageSalesPagination);
    this.pageSalesPaginationPage = document.querySelectorAll(this.SELECTORS.pageSalesPaginationPage);
  }

  // sales part
  salesPaginationHandling(refresh = false) {
    // check
    let paginationLinks = (refresh) ? document.querySelectorAll(this.SELECTORS.pageSalesPaginationPage) : this.pageSalesPaginationPage;
    if (paginationLinks == null) return false;
    // global
    let ctx = this;
    // intercept click
    paginationLinks.forEach(btn => {
      // adding listener
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        // check if active, do nothing
        if (btn.classList.contains(ctx.CLASSES.salesLinkActive)) return false;
        // loader
        this.$emit(this.$customEvents.LOADER_EVENTS.show);
        // url to call
        let query = btn.getAttribute('href');
        // call new page
        this.ajaxAction.getPage(query).then(newPage => {
          // parse response
          let response = new DOMParser ().parseFromString(newPage, 'text/html');
          // render content
          this.ajaxAction.renderContent(newPage,'products');
          // update url
          history.replaceState(null, null, query);
          // emit events
          this.$emit(this.$customEvents.FILTERS_EVENTS.pageLoaded, {
            response: response,
            res: newPage,
            query: query
          });
          this.$emit(this.$customEvents.LOADER_EVENTS.hide);
          this.$emit(this.$customEvents.PAGINATION_EVENTS.pageUpdated, {
            response: response,
            res: newPage,
            query: query
          });
          // scroll to top
          window.scrollTo(0, 0);
        });

      });
    });
  }

  // pagination refresh
  salesPaginationRefresh(payload) {
    if (this.pageSalesPagination != null) {
      let newPagination = payload.response.querySelector(this.SELECTORS.pageSalesPagination);
      if (newPagination != null) {
        this.pageSalesPagination.innerHTML = newPagination.innerHTML;
        // refresh pagination
        this.salesPaginationHandling(true);
      } else {
        this.pageSalesPagination.innerHTML = '';
      }
    }
  }

  bindEvents() {

    // pager update on filters
    this.$on(this.$customEvents.FILTERS_EVENTS.pageLoaded, ({event, payload}) => {
      if(this.pageSalesPagination != null) {
        // refresh pagination
        this.salesPaginationHandling(true);
      }
      let carousel = new CarouselComponent();
      carousel.render();
    });

    // pager update on pagination
    this.$on(this.$customEvents.PAGINATION_EVENTS.pageUpdated, ({event, payload}) => {
      // sales pagination replace html and reset
      this.salesPaginationRefresh(payload);
    });
    // pager update on filters
    this.$on(this.$customEvents.FILTERS_EVENTS.updated, ({event, payload}) => {
      // sales pagination replace html and reset
      this.salesPaginationRefresh(payload);
    });

    // components part
    this.$on(CustomEvents.FILTERS_EVENTS.updated, function (e) {
      let carousel = new CarouselComponent();
      carousel.render();
    });

  }

  render() {
    this.log('rendering...');
    $(document).on('click',this.SELECTORS.pagers,function(e){
      e.preventDefault()
      const {filtersTextsearch,filtersPagesize} = document.querySelector('[data-filters]').dataset;
      location.href=buildFullQuery({
        textSearch: filtersTextsearch,
        size: filtersPagesize,
        query: buildQuery(),
        page: $(this).data('page')
      })
    })
    // main events
    this.bindEvents();
    // sales paginator
    this.salesPaginationHandling();

  }
}
